export default {
    submittedForApproval: 'Submitted for Approval',
    resultsDefaultPageSize: 20,
    collegeTeamEmail: 'college@universaltennis.com',
    highSchoolTeamEmail: 'hsteam@universaltennis.com',
    vipHighSchoolEmail: 'viphs@universaltennis.com',
    clubsEmail: 'am@universaltennis.com',
};
